import { render } from "./ApontamentoAgrupado.vue?vue&type=template&id=2bd8c120&scoped=true"
import script from "./ApontamentoAgrupado.vue?vue&type=script&lang=js"
export * from "./ApontamentoAgrupado.vue?vue&type=script&lang=js"

import "./ApontamentoAgrupado.vue?vue&type=style&index=0&id=2bd8c120&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd8c120"]])

export default __exports__